import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { Observable } from "rxjs";
import { HttpClient, HttpHeaders, HttpResponse } from "@angular/common/http";
import { AuthServiceResult } from "./auth.service-result";
import { map } from "rxjs/operators";
//import { CookieService } from "ngx-cookie-service";
import { CookieService } from "ngx-cookie";
import { User } from '../models/user';
import { Role } from "../models/role";




@Injectable({
  providedIn: "root",
})
export class AuthService {
  isLoggedIn: boolean = false;

  private user: User;

  private endpoint = environment.apiBaseUrl + '/admin/security';
  // store the URL so we can redirect after logging in
  redirectUrl: string;

  serviceResult: AuthServiceResult;

  constructor(private http: HttpClient, private cookieService: CookieService) {
    this.serviceResult = new AuthServiceResult();
    this.user = new User();
  }


  /**
   * Dado las credenciales, valida que sean correstas contra el LDAP corporativo
   * 
   * @param username  Nombre de usuario
   * @param password  Clave de usuario
   */
  login(username: string, password: string): Observable<AuthServiceResult> {
    var params = { user: username, password: password };
    const httpOptions = {
      headers: new HttpHeaders({ "Content-Type": "application/json" }),
    };

    return this.http
      .post(`${this.endpoint}/authenticate`, params, httpOptions)
      .pipe(
        map((res: AuthServiceResult) => {
          if (res.statusCode === 200) {
            this.isLoggedIn = true;
            this.user.username = params.user;
            //Creo la cookie AUTHENTICATED_USERNAME que expira en 24 horas
            //this.cookieService.set("AUTHENTICATED_USERNAME",this.user.username,1,"/");
            this.cookieService.put("AUTHENTICATED_USERNAME", this.user.username);
          }
          else {
            this.isLoggedIn = false;
          }

          return res;
        })
      );
  }

  logout(): void {
    this.isLoggedIn = false;
    this.user = new User();
    /*
    this.cookieService.delete("AUTHENTICATED_USERNAME");
    this.cookieService.delete("GLOBALSESSIONID");
    */
    this.cookieService.remove("AUTHENTICATED_USERNAME");
    this.cookieService.remove("GLOBALSESSIONID");

  }

  getUsername(): string {
    return this.user.username;
  }

  getUser(): User {
    return this.user;
  }

  getUserRoles(username: string) {
    return this.http.get(`${this.endpoint}/perfiles/usuario/` + username);
  }

  getUserAreasFuncionales(username: string) {
    return this.http.get(`${this.endpoint}/areasfuncionales/usuario/` + username);
  }

  validarSesionUsuario() {
    return this.http.get(`${this.endpoint}/validarSesionUsuario` );
  }

  esAdministrador(): boolean {
    let esAdministrador: boolean = false;

    for (let role of this.user.roles) {
      if (role == Role.Admin || role == Role.MenuAdministrator) {
        esAdministrador = true;
        break;
      }
    }

    return esAdministrador;
  }

}
